<template>
  <b-card>
    <b-card-header>
      <h4 class="title">ویرایش واحد سازمانی</h4>
    </b-card-header>
    <b-card-body>
      <validation-observer #default="handleSubmit" ref="refFormObserver">
        <b-form @submit.prevent>
          <b-row>
            <b-col md="6" class="mb-2">
              <validation-provider
                #default="validationContext"
                name="نام واحد"
                rules="required"
              >
                <b-form-group>
                  <label for="name">
                    <feather-icon icon="FileTextIcon" class="mr-50" />
                    نام واحد
                  </label>
                  <b-form-input
                    v-model="name"
                    id="name"
                    placeholder="نام واحد را وارد نمایید"
                    :state="getValidationState(validationContext)"
                    trim
                  />
                  <b-form-invalid-feedback>
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col md="6" class="mb-2">
              <b-form-group label="سازمان مادر (اختیاری)">
                <b-overlay :show="loadingDropdowns" spinner-small>
                  <v-select
                    v-model="parent_id"
                    :options="
                      organizationsList.filter(
                        (org) => org.id !== Number($route.params.id),
                      )
                    "
                    label="name"
                    :reduce="(org) => org.id"
                    placeholder="انتخاب سازمان مادر..."
                    dir="rtl"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>

            <b-col md="6" class="mb-2">
              <b-form-group label="مدیران سازمان">
                <b-overlay :show="loadingDropdowns" spinner-small>
                  <v-select
                    v-model="manager_ids"
                    multiple
                    :close-on-select="false"
                    :options="managersList"
                    label="name"
                    :reduce="(manager) => manager.id"
                    placeholder="انتخاب مدیر..."
                    dir="rtl"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>

            <b-col md="6" class="mb-2">
              <b-form-group label="کاربران عادی سازمان">
                <b-overlay :show="loadingDropdowns" spinner-small>
                  <v-select
                    v-model="user_ids"
                    multiple
                    :close-on-select="false"
                    :options="usersList"
                    label="name"
                    :reduce="(user) => user.id"
                    placeholder="انتخاب کاربران..."
                    dir="rtl"
                  />
                </b-overlay>
              </b-form-group>
            </b-col>

            <b-col md="6" class="mb-2 d-flex align-items-center">
              <b-form-group class="mb-0">
                <b-form-checkbox
                  id="isActive"
                  class="custom-control-success"
                  switch
                  v-model="isActive"
                >
                  فعال
                </b-form-checkbox>
              </b-form-group>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
      <button
        class="btn btn-warning mt-2"
        @click="updateUser"
        :disabled="onProgress"
      >
        <b-spinner v-if="onProgress" small class="mr-1"></b-spinner>
        ویرایش واحد سازمانی
      </button>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BForm,
  BFormGroup,
  BFormInput,
  BOverlay,
  BFormCheckbox,
  BFormInvalidFeedback,
  BSpinner,
} from "bootstrap-vue";
import VSelect from "vue-select";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import farsi from "vee-validate/dist/locale/fa";
import formValidation from "@core/comp-functions/forms/form-validation";
import { required } from "@core/utils/validations/validations";

export default {
  name: "Organization_Update",
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInvalidFeedback,
    BFormCheckbox,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BForm,
    BFormGroup,
    BFormInput,
    BOverlay,
    VSelect,
    BSpinner,
  },
  data() {
    return {
      name: "",
      isActive: true,
      parent_id: null,
      manager_ids: [],
      user_ids: [],

      organizationsList: [],
      managersList: [],
      usersList: [],

      loadingDropdowns: false,
      onProgress: false,
    };
  },
  created() {
    localize("fa", { messages: farsi.messages });
  },
  mounted() {
    this.fetchDropdownData();
  },
  methods: {
    async fetchDropdownData() {
      this.loadingDropdowns = true;
      try {
        const [orgs, managers, users] = await Promise.all([
          this.$http.get("organizations"),
          this.$http.get("users/for-select"),
          this.$http.get("users/for-select"),
        ]);

        this.organizationsList = orgs.data.organizations || [];
        this.managersList = managers.data.data || [];
        this.usersList = users.data.data || [];

        this.getUser();
      } catch (error) {
        this.$bvToast.toast("خطا در دریافت لیست‌های پایه", {
          title: "خطا",
          variant: "danger",
        });
      } finally {
        this.loadingDropdowns = false;
      }
    },
    getUser() {
      this.$http
        .get(`organizations/${this.$route.params.id}`)
        .then(({ data }) => {
          if (data.status) {
            const org = data.organization;

            this.name = org.name;
            this.isActive = org.isActive;

            this.parent_id =
              org.parent_id || (org.parent ? org.parent.id : null);

            const rawManagers =
              org.manager_ids || org.managerIds || org.managers || [];
            this.manager_ids = rawManagers.map((item) => {
              return typeof item === "object" ? Number(item.id) : Number(item);
            });
            const rawUsers = org.user_ids || org.userIds || org.users || [];
            this.user_ids = rawUsers.map((item) => {
              return typeof item === "object" ? Number(item.id) : Number(item);
            });
            console.log("Parsed Data for v-select:", {
              parent_id: this.parent_id,
              manager_ids: this.manager_ids,
              user_ids: this.user_ids,
            });
          } else {
            this.$bvToast.toast("دریافت واحد سازمانی با خطا مواجه شد", {
              title: "خطا",
              variant: "danger",
            });
          }
        })
        .catch((error) => {
          this.$bvToast.toast(error.response?.data?.message ?? error.message, {
            title: "خطا",
            variant: "danger",
          });
        });
    },
    updateUser() {
      this.$refs.refFormObserver.validate().then((success) => {
        if (success) {
          this.onProgress = true;
          this.$http
            .put(`organizations/${this.$route.params.id}`, {
              name: this.name,
              is_active: this.isActive,
              parent_id: this.parent_id,
              manager_ids: this.manager_ids,
              user_ids: this.user_ids,
            })
            .then(({ data }) => {
              if (data.status) {
                this.$bvToast.toast("واحد سازمانی با موفقیت ویرایش شد", {
                  title: "موفقیت",
                  variant: "success",
                });
                this.$router.push({ name: "Organization_Unit_List" });
              } else {
                this.$bvToast.toast("در ویرایش واحد سازمانی خطایی رخ داده", {
                  title: "خطا",
                  variant: "danger",
                });
              }
            })
            .catch((error) => {
              this.$bvToast.toast(
                error.response?.data?.message ?? error.message,
                { title: "خطا", variant: "danger" },
              );
            })
            .finally(() => {
              this.onProgress = false;
            });
        }
      });
    },
  },
  setup() {
    const { getValidationState } = formValidation(name);
    return { getValidationState };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
